import { render, staticRenderFns } from "./ModalAddEditEdge.vue?vue&type=template&id=ca5f3cb4&scoped=true&lang=html&"
import script from "./ModalAddEditEdge.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditEdge.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditEdge.vue?vue&type=style&index=0&id=ca5f3cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5f3cb4",
  null
  
)

export default component.exports